import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ecaa24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pc-form" }
const _hoisted_2 = { class: "block-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "1. 你是谁？", -1))
const _hoisted_4 = { class: "xag-select" }
const _hoisted_5 = {
  key: 0,
  value: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xag-select-icon iconfont icon-down" }, null, -1))
const _hoisted_7 = { class: "block-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "2. 是否匿名？", -1))
const _hoisted_9 = { class: "xag-select" }
const _hoisted_10 = {
  key: 0,
  value: ""
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xag-select-icon iconfont icon-down" }, null, -1))
const _hoisted_13 = { class: "block-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "3. 是否需要调查结果反馈?", -1))
const _hoisted_15 = { class: "xag-select" }
const _hoisted_16 = {
  key: 0,
  value: ""
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xag-select-icon iconfont icon-down" }, null, -1))
const _hoisted_19 = { class: "block-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createTextVNode("4. 投诉对象?"),
  /*#__PURE__*/_createElementVNode("span", { class: "requried" }, "（必填）")
], -1))
const _hoisted_21 = { class: "block-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createTextVNode("5. 投诉对象职务?"),
  /*#__PURE__*/_createElementVNode("span", { class: "requried" }, "（必填）")
], -1))
const _hoisted_23 = { class: "block-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createTextVNode("6. 投诉内容?"),
  /*#__PURE__*/_createElementVNode("span", { class: "requried" }, "（必填）")
], -1))
const _hoisted_25 = { class: "block-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, "7. 相关证据资料", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-tips" }, "图片、聊天记录、转账记录等证据资料;文件大小不超过20M", -1))
const _hoisted_28 = { class: "upload-file-item-wrap" }

import type { UploadFileDataItem } from '@/types/public'
import { ref, withDefaults, reactive } from 'vue'
import UploadFileGroup from '@/components/upload-new/UploadFileGroup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-audit-form',
  props: {
    anonymousActions: { default: () => [] },
    userTypeOptions: { default: () => [] },
    feedbackOptions: { default: () => [] },
    formData: { default: () => ({}) }
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as { anonymousActions: Array<any>, userTypeOptions: Array<any>, feedbackOptions: Array<any>, formData: Record<string, any> };




const value = ref(0)

function formChange(e: any, field: string) {
  const value = e?.target?.value || ''
  emits('change', {
    field,
    value,
  })
}

function uploadFileChange(data: UploadFileDataItem[]) {
  emits('change', {
    field: 'fileInfos',
    value: data.map((item) => ({
      ...item,
      // status: 'uploading',
    })),
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("select", {
          placeholder: "请选择",
          class: _normalizeClass(props.formData?.useType ? '' : 'empty-select'),
          ref: "userTypeSelect",
          onChange: _cache[0] || (_cache[0] = (e) => formChange(e, 'useType'))
        }, [
          (!props.formData?.useType)
            ? (_openBlock(), _createElementBlock("option", _hoisted_5, "请选择"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.userTypeOptions, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.name
            }, _toDisplayString(item.name), 1))
          }), 128))
        ], 34),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("select", {
          placeholder: "请选择",
          class: _normalizeClass(props.formData?.isAnonymous ? '' : 'empty-select'),
          onChange: _cache[1] || (_cache[1] = (e) => formChange(e, 'isAnonymous'))
        }, [
          (!props.formData?.isAnonymous)
            ? (_openBlock(), _createElementBlock("option", _hoisted_10, "请选择"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.anonymousActions, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.name
            }, [
              _createTextVNode(_toDisplayString(item.name), 1),
              (item.subname)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "（" + _toDisplayString(item.subname) + "）", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 34),
        _hoisted_12
      ]),
      (props.formData?.isAnonymous && props.formData?.isAnonymous !== '是')
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "xag-input xag-input-after",
            type: "text",
            onChange: _cache[2] || (_cache[2] = (e) => formChange(e, 'userContract')),
            placeholder: "请输入"
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("select", {
          placeholder: "请选择",
          class: _normalizeClass(props.formData?.isNeedFeedback ? '' : 'empty-select'),
          onChange: _cache[3] || (_cache[3] = (e) => formChange(e, 'isNeedFeedback'))
        }, [
          (!props.formData?.isNeedFeedback)
            ? (_openBlock(), _createElementBlock("option", _hoisted_16, "请选择"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.feedbackOptions, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.name
            }, [
              _createTextVNode(_toDisplayString(item.name), 1),
              (item.subname)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "（" + _toDisplayString(item.subname) + "）", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 34),
        _hoisted_18
      ]),
      (props.formData?.isNeedFeedback && props.formData?.isNeedFeedback !== '否')
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "xag-input xag-input-after",
            type: "text",
            onChange: _cache[4] || (_cache[4] = (e) => formChange(e, 'userContract')),
            placeholder: "请输入"
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("input", {
        class: "xag-input mt24",
        type: "text",
        onChange: _cache[5] || (_cache[5] = (e) => formChange(e, 'complaintName')),
        placeholder: "请输入"
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("input", {
        class: "xag-input mt24",
        type: "text",
        onChange: _cache[6] || (_cache[6] = (e) => formChange(e, 'complaintPosition')),
        placeholder: "请输入"
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("textarea", {
        class: "xag-textarea mt24",
        type: "text",
        onChange: _cache[7] || (_cache[7] = (e) => formChange(e, 'complaintContent')),
        placeholder: "请输入"
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createVNode(UploadFileGroup, {
          useAction: false,
          uploadTo: "integrated",
          fileSizeLimit: 20480,
          fileSizeLimitMessage: "存在单个文件大小超过20M",
          onChange: uploadFileChange
        })
      ])
    ])
  ]))
}
}

})